<template>
    <div class="modal-content col-md-3">
        <div class="d-flex flex-column p4">
            <h3>Welcome to Crime Time!</h3>
            <p>Please check your email for your account verification code.</p>
            <span v-if="err?.length > 1" style="font-size: 10px; color: red;">{{err}}</span>
            <input class="form-control form-control-md mb-5" type="text" v-model="code" placeholder="Enter 6 digit code">
            <button class="btn btn-primary" @click="submit">Submit</button>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios';
export default {
    name: 'EmailConfirmation',
    setup() {
        return {
            code: '',
            err: '',
        }
    },
    props: {
        email: {
            type: String,
            required: true,
        }, 
    },
    methods: {
        async submit() {
            let token = localStorage.getItem('user_token');  
            axios.post(process.env.VUE_APP_ENDPOINT + '/api/registration/validateEmail', {
                code: this.code
            }, {
                headers: { Authorization: `Bearer ` + token }
            }).then(result => {
                if (result.data.emailConfirmed == true) {
                    this.$emit('emailConfirmed');
                    
                } else {
                    this.err = 'Invalid Code'
                }
            }).catch(err => {
                this.err = 'Invalid Code'
            })
        }
    }
}
</script>